module.exports = __webpack_public_path__ + "img/LogoSBG.294449a9.png";